import styles from '../styles/history.module.scss';

function History() {
  return (
    <div className={styles.history}>
      <div>
        <h3>Game Description</h3>
        <div>
          <p>
            Backgammon, one of the oldest games in existence, dates back more than 4000 years and is believed
            to have been developed by the ancient Egyptians. It is not a game of luck as many perceive, but
            rather, a strategic visual game of war; in many ways as difficult to master as chess or checkers.
            Although an element of luck is involved, a skilled player uses intuition, creativity and
            psychology to beat the opponent.
          </p>
          <p>
            A variant closest to the modern backgammon dates back to 500 A.D. Persia, where the game of Nard
            (or Nardi) was the first to use 2 die to govern the movement of checkers. The setup of the modern
            backgammon is identical to Nard backgammon with play commencing from a fixed arrangement of the
            checkers on the board.
          </p>
          <p>
            The goal of this game is to move all player's checkers into his home board and then bear them off
            (i.e. remove them from the board). The first player to remove all of his checkers wins the game.
          </p>
        </div>
      </div>
      <div>
        <h3>Board & Pieces</h3>
        <div>
          <ul>
            <li>An online Java-based Backgammon board.</li>
            <li>Thirty round checkers - 15 each of two different colors - Black and White.</li>
            <li>A pair of regular dice, numbered from 1 to 6.</li>
            <li>
              A doubling six-faced cube, marked with the numerals 2,4,8,16,32 & ; 64. This cube is used to
              keep track of the number of units at stake in each game, as well as to mark the player who last
              doubled.
            </li>
          </ul>
          <p>
            Backgammon is typically a two-player board game consisting of player's and opponents' "home"
            boards and "outer" boards. Each board is subdivided into six alternately colored triangles
            called "points". The home and outer boards are separated down the center by a partition called
            the "bar".
          </p>
          <p>
            The points are numbered for either player starting in that player's home board. The outermost
            point is the twenty-four point, which is also the opponent's one point. Each player has fifteen
            checkers of his own color. The initial board arrangement of checkers is: two on each player's
            twenty-four point, five on each player's thirteen point, three on each player's eight point, and
            five on each player's six point.
          </p>
        </div>
      </div>
    </div>
  );
}

export default History;
